export enum ErrorMessages {
  INVALID_DATE = 'Provide a valid date',
  INVALID_EMAIL = 'Pick a valid email',
  REQUIRED_FIELD = 'This field is required',
  MUST_BE_CHECKED = 'Field must be checked',
  INVALID_URL = 'Enter a valid URL',
  FUTURE_DATE = 'Date must be set in the future',
}
